import { chunk } from 'utils/array';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import styles from './Table.module.scss';
import type { IBlockTableFields } from 'types/contentful/generated';

const Table = ({
  blockId,
  columns,
  columnNames,
  tableItems,
  title,
}: IBlockTableFields): JSX.Element => {
  const rows = chunk(tableItems, columns);

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.tableContainer}>
        <table>
          {columnNames && (
            <thead>
              <tr>
                {columnNames.map((column, i) => {
                  const options = column.match(/_/) ? column.split('_') : [];
                  return (
                    <th
                      className="p-3"
                      colSpan={isNaN(+options[1]) ? 1 : +options[1]}
                      key={i}
                    >
                      {options[0] || column}
                    </th>
                  );
                })}
              </tr>
            </thead>
          )}
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={styles.row}>
                {row.map((column, index) => {
                  const options = column.match(/_/) ? column.split('_') : [];
                  return (
                    <td
                      className="p-3"
                      colSpan={isNaN(+options[1]) ? 1 : +options[1]}
                      rowSpan={isNaN(+options[2]) ? 1 : +options[2]}
                      key={index}
                    >
                      {options[0] || column}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
